import { DataLayerEventName, EntitledToView } from '@news-mono/web-common'
import React, { useCallback } from 'react'
import { PromoCardProps } from '../PromoCard'
import {
    StyledPromoCard,
    StyledPromoImg,
    StyledPromoLink,
} from '../PromoCard.styled'

type FootyLivesHerePromoProps = Omit<PromoCardProps, 'promoType'>

const EntitledView = ({ onEvent }: FootyLivesHerePromoProps) => {
    const promo = require('../assets/footy-lives-here-logged-in.webp')

    const onLinkClick = useCallback(() => {
        onEvent?.({
            type: DataLayerEventName.selectItemEvent,
            originator: 'AFLSeasonGuidePromoCard',
            payload: {
                index: 0,
                item_brand: 'The West Australian',
                item_category: 'news/promotions',
                item_category2: 'redirect',
                item_id: 'afl_season_guide_promo_card',
                item_list_category: 'sports-afl-season-guide-promo',
                item_name: 'AFL Season Guide Promo Card',
                item_variant: false,
                price: 0.0,
                link_text: 'Read now',
                link_url:
                    'https://thegame.com.au/play?utm_source=Acquisition&utm_medium=AFL+Page&utm_campaign=AFL+2026&utm_term=Weekly+Prize',
            },
        })
    }, [onEvent])

    return (
        <StyledPromoCard promotion="footy-lives-here">
            <StyledPromoLink
                to={
                    'https://thegame.com.au/play?utm_source=Acquisition&utm_medium=AFL+Page&utm_campaign=AFL+2026&utm_term=Weekly+Prize'
                }
                openExternalInNewWindow={false}
                onClick={onLinkClick}
            >
                <StyledPromoImg
                    src={promo}
                    alt="Win up to $1,000 each round with The Game. Click here to play."
                />
            </StyledPromoLink>
        </StyledPromoCard>
    )
}

const OpportunityView = () => {
    const promo = require('../assets/footy-lives-here-logged-out.webp')
    return (
        <StyledPromoCard promotion="footy-lives-here">
            <StyledPromoLink to={'/sport/afl/subscribe'}>
                <StyledPromoImg
                    src={promo}
                    alt="Sign up for a season of footy and get up to 25% off. Subscribe now."
                />
            </StyledPromoLink>
        </StyledPromoCard>
    )
}

export const FootyLivesHerePromoCard = ({
    onEvent,
}: FootyLivesHerePromoProps) => {
    return (
        <EntitledToView
            requiredAccess={{ level: 'subscriber' }}
            entitled={() => {
                return <EntitledView onEvent={onEvent} />
            }}
            notEntitled={() => {
                return <OpportunityView />
            }}
        />
    )
}
